export const loginUser = (jwt, user) => ({ type: 'auth/LOGIN', jwt, user });
export const logoutUser = () => ({ type: 'auth/LOGOUT' });

export const loadUsers = (users) => ({ type: 'data/load/USERS', users });
export const createUser = (user) => ({ type: 'data/new/USERS', user });
export const updateUser = (id, changes) => ({
  type: 'data/update/USERS',
  id,
  changes,
});
export const deleteUsers = (ids) => ({ type: 'data/delete/USERS', ids });

export const toggleOnEditMode = () => ({ type: 'data/editMode/On' });
export const toggleOffEditMode = () => ({ type: 'data/editMode/Off' });
